import React from "react";
import { Checkbox, Grid, Header, Input } from "semantic-ui-react";
import { AlignSelector } from "../components";
import { getWidget } from "../widgetUtils";
import { WidgetEditor } from "../WidgetEditor";

import "./MultiTrackMediaPlayerWidgetEditor.css";
import WidgetNameInput from "../components/WidgetNameInput/WidgetNameInput";

class MultiTrackMediaPlayerWidgetEditor extends WidgetEditor {
  static header = "Multi Track Media Player";

  updateAlign(e, data) {
    this.updateWidgetConfig((widgetConfig) => {
      widgetConfig.align = data;
      widgetConfig.justify = data === "justify";
    });

    this.setState({}); // force re-render
  }

  render() {
    const config = getWidget(this.props.getWidgetConfig(), this.state.widgetId);
    const width = config.width || null;
    const height = config.height || null;
    const labelMaxLength = config.labelMaxLength || null;

    return (
      <Grid className={"MultiTrackMediaPlayerWidgetEditor"}>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <WidgetNameInput
              widgetId={this.state.widgetId}
              updateId={this.updateId}
              checkIdUnique={this.props.checkIdUnique}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={2} divided>
          <Grid.Column textAlign="center">
            <Header as="h4">Player width</Header>
            <Input
              width={12}
              size="mini"
              placeholder="Value"
              type="number"
              value={width}
              onChange={(e) => this.updateConfig("width", e.target.value)}
            />
            <Header as="h4">Player height</Header>
            <Input
              width={12}
              size="mini"
              placeholder="Value"
              type="number"
              value={height}
              onChange={(e) => this.updateConfig("height", e.target.value)}
            />
            <Header as="h4">Align</Header>
            <AlignSelector
              justify
              size="mini"
              value={config.align}
              onChange={(e, data) => this.updateConfig("align", data)}
            />
          </Grid.Column>
          <Grid.Column textAlign="center">
            <Header as="h4">Force video mute</Header>
            <Checkbox
              toggle
              checked={config.muteVideo || false}
              onChange={(e, data) =>
                this.updateConfig("muteVideo", data.checked)
              }
            />
            <Header as="h4">Label read only</Header>
            <Checkbox
              toggle
              checked={config.labelReadOnly || false}
              onChange={(e, data) =>
                this.updateConfig("labelReadOnly", data.checked)
              }
            />
            <Header as="h4">Label width</Header>
            <Input
              width={12}
              size="mini"
              placeholder="Value"
              type="number"
              value={labelMaxLength}
              onChange={(e) =>
                this.updateConfig("labelMaxLength", e.target.value)
              }
            />
            <Header as="h4">Gain offset</Header>
            <Input
              width={12}
              size="mini"
              placeholder="Value"
              type="number"
              value={config.gainCorrection}
              min={-100}
              max={-1}
              onChange={(e) =>
                this.updateConfig("gainCorrection", e.target.value)
              }
            />
          </Grid.Column>
        </Grid.Row>
        {this.renderButtons()}
        {this.renderPreview()}
      </Grid>
    );
  }
}

export default MultiTrackMediaPlayerWidgetEditor;
